var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.977 7.648a.843.843 0 0 1 0 1.23.848.848 0 0 1-.602.247.866.866 0 0 1-.629-.246L4.875 6.008l-2.898 2.87a.848.848 0 0 1-.602.247.866.866 0 0 1-.629-.246.843.843 0 0 1 0-1.23L3.617 4.75.747 1.879a.843.843 0 0 1 0-1.23.843.843 0 0 1 1.23 0l2.898 2.87L7.746.65a.843.843 0 0 1 1.23 0 .843.843 0 0 1 0 1.23l-2.87 2.898 2.87 2.871z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.2b2a9881d0a1c8530f0d2cd6f4237fb6.svg";
export { ForwardRef as ReactComponent };